import { render } from "./myjrPage.vue?vue&type=template&id=19a0ff98"
import script from "./myjrPage.vue?vue&type=script&lang=js"
export * from "./myjrPage.vue?vue&type=script&lang=js"

import "./myjrPage.vue?vue&type=style&index=0&id=19a0ff98&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__